import { render, staticRenderFns } from "./permintaan_layanan.vue?vue&type=template&id=602a5390&"
import script from "./permintaan_layanan.vue?vue&type=script&lang=js&"
export * from "./permintaan_layanan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QList,QItemLabel,QItem,QItemSection,QIcon,QDialog,QRadio,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QImg,QList,QItemLabel,QItem,QItemSection,QIcon,QDialog,QRadio,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
